import { apiAction } from './api';

export const GET_TIMECARD = 'GET_TIMECARD';
export const SET_TIMECARD = 'SET_TIMECARD';
export const CREATE_TIMECARD = 'CREATE_TIMECARD';
export const SUBMIT_TIMECARD = 'SUBMIT_TIMECARD';
export const SET_TIMECARD_STATS = 'SET_TIMECARD_STATS';
export const SAVE_WORKDAY = 'SAVE_WORKDAY';

import endpoints from './endpoints';
import { getUser, setUser } from './user';
import { checkForNowPlaying, resetDraft } from './draft';
import { setMessage } from './message';

export const getTimecard = (timecardId) => {
  return apiAction({
    url: endpoints.getTimecard,
    data: { timecardId },
    onSuccess: [setTimecard, (payload) => checkForNowPlaying(payload)],
    label: GET_TIMECARD,
    showLoading: true,
  });
};

export const createTimecard = () => {
  return apiAction({
    url: endpoints.createTimecard,
    method: 'POST',
    onSuccess: [
      setTimecard,
      resetDraft,
      getUser,
      () => setMessage('Timecard created', 'info'),
    ],
    label: CREATE_TIMECARD,
  });
};

export const setTimecard = (data) => {
  return {
    type: SET_TIMECARD,
    payload: data,
  };
};

export const submitTimecard = (id) => {
  return apiAction({
    url: endpoints.submit,
    method: 'PUT',
    data: { id },
    label: SUBMIT_TIMECARD,
    onSuccess: [
      (data) => setUser(data),
      (data) => getTimecard(data.currentTimecardId),
      () => setMessage('Submitted successfully - new timecard loaded', 'info'),
    ],
  });
};

export const saveWorkday = (workday) => {
  return apiAction({
    url: endpoints.putWorkday,
    method: 'PUT',
    onSuccess: (data) => setTimecard(data),
    data: workday,
    label: SAVE_WORKDAY,
  });
};

export const retractTimecard = (id) => {
  return apiAction({
    url: endpoints.retract,
    method: 'PUT',
    data: { id },
    onSuccess: [
      (data) => setUser(data),
      (data) => getTimecard(data.currentTimecardId),
      () => setMessage('Timecard retracted', 'info'),
    ],
  });
};

const initialState = {
  timecardId: null,
  status: null,
  startDate: '',
  endDate: '',
  totals: {
    billed: 0,
    noCharge: 0,
    worked: 0,
    vacation: 0,
    holiday: 0,
    sick: 0,
  },
  kpis: {
    tips: [],
  },
  workdays: [],
  entries: [],
};

export const timecard = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIMECARD:
      return action.payload;
    default:
      return state;
  }
};
